module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDialogShow),
      expression: "isDialogShow"
    }],
    ref: "dialog",
    attrs: {
      "title": _vm.title,
      "modal": false
    },
    domProps: {
      "value": (_vm.isDialogShow)
    },
    on: {
      "open": _vm.initDialog,
      "close": _vm.closeDialog,
      "input": function($event) {
        _vm.isDialogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "ovf-hd m-b-10"
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchUser),
      expression: "searchUser"
    }],
    staticClass: "w-180",
    attrs: {
      "placeholder": "请输入要搜索的用户名称"
    },
    domProps: {
      "value": (_vm.searchUser)
    },
    on: {
      "change": _vm.changeSearchUser,
      "input": function($event) {
        _vm.searchUser = $event
      }
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchStruct),
      expression: "searchStruct"
    }],
    staticClass: "m-l-10",
    attrs: {
      "clearable": "",
      "placeholder": "请选择部门"
    },
    domProps: {
      "value": (_vm.searchStruct)
    },
    on: {
      "change": _vm.changeSearchStruct,
      "input": function($event) {
        _vm.searchStruct = $event
      }
    }
  }, _vm._l((_vm.structData), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "table",
    attrs: {
      "data": _vm.tableData,
      "height": "300",
      "highlight-current-row": ""
    },
    on: {
      "select": _vm.handleSelectionChange,
      "select-all": _vm.handleSelectionAll,
      "current-change": _vm.handleSingleChange
    }
  }, [(!_vm.isOnly || _vm.isOnly == 20) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "realname",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "s_name",
      "label": "部门"
    }
  })]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOnly || _vm.isOnly != 10),
      expression: "!isOnly || isOnly != 10"
    }],
    staticClass: "fl m-b-5"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeThis
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00227189!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/peopleSelect.vue
// module id = 1751
// module chunks = 2